import {Injectable, Pipe} from '@angular/core';

/*
 Generated class for the Highlight pipe.

 See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 Angular 2 Pipes.
 */
@Pipe({
  name: 'highlight'
})
@Injectable()
export class HighlightPipe {
  transform(text, phrases) {
    for (let phrase of phrases) {
      // $log.debug('phrase:' + phrase);
      if (phrase) {
        text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
          '<strong>$1</strong>')
      }
    }

    // $log.debug('text');
    // $log.debug(text);
    // return $sce.trustAsHtml(text);
    return text;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/highlight.ts